<template>
  <div class="modal-backdrop pt-5">
    <div class="card col-lg-3 col-md-8 mt-md-4 col-11 p-0 mx-auto">
      <div class="modal-content border-0">
        <!-- <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel">Update</h5>        
          <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div> -->
        <div class="modal-body bodymodal11 bodymodal13" id="accordion">
          <div class="pt-5">
              <h5 class="modal-title fontsize16 black80 proximanova-bold text-center" id="exampleModalLabel">Update</h5>
                <div class="opacityfont-12 d-flex mt-3">
                    <span class="terms-conditions ml-5">
                        <a href="https://worknotion.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>, 
                        <a href="https://worknotion.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy & Policies</a>
                    </span>
                </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="mr-3 btn black border borderradius20 mouseoverbtn1" @click="close">
            <span class="proximanova">Cancel</span>
          </button>
          <button class="mr-3 btn backgroundcolorblack white mouseoverbtn2 borderradius20" @click="UpdateVersion">
            <span class="button-create-font proximanova">Update</span>
          </button>
          </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserdetails from "@/js/http-userdetails.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      
    }
  },
  methods:{
    close() {
        this.$emit('closeversion');
    },
    //update user versions
    UpdateVersion() {
        let userId = sessionUtils.getUserId()
        let updatedPrivacyVersion = localStorage.getItem('privacyPolicyVersion')
        let updatedTermsVersion = localStorage.getItem('termsConditionsVersion')
        httpuserdetails.put('/updateUserVersion',{
            userId : userId,
            termsConditionsVersion: updatedTermsVersion,
            privacyPolicyVersion : updatedPrivacyVersion
        }).then((response) => {
            console.log(response)
            this.close()
        }).catch((e) => {
            console.log(e)
            this.close()
        })
    }
  },
   mounted() {
    
  },

}

</script>

<style>
@import '../css/modal.css';
</style>